var XPortal = XPortal || {};
XPortal.AutofillFields = (function () {
    var self = {
        debug: false,
        models: [],
        relations: [],
        timeOut: 300,
        trace: function () {
            if (!self.debug) return;
            try {
                console.log.apply(console, ["%c[autofill]", "color:#0a7;font-weight:bold"].concat(Array.prototype.slice.call(arguments)));
            } catch (e) { }
        },
        initModel: function (storeModel) {
            const model = storeModel.model;
            const entityUId = (storeModel.entity || {}).UniqueId || "";

            const reqItem = {
                nodeId: model.NodeId,
                modelName: model.modelName,
                entityUId: entityUId,
                parentInfo: model.ParentInfo || XPortal.Grid.GetModelParentInfo(model.modelName),
                parentModelName: XPortal.Grid.GetModelParentName(model.modelName) || model.modelName,
                autofillFieldsSetup: model.AutofillFields,
                selector: model.selector,
                batchUpdateTimeout: null,
                batchUpdateTimeouts: {},
                requestNumber: 0, // Tracks the latest update request to prevent outdated updates
                alias: model.EntityAlias || model.Alias,
            };

            const entityIndex = self.models.findIndex(item => item.nodeId === reqItem.nodeId);

            if (entityIndex !== -1)
                self.models[entityIndex] = Object.assign(self.models[entityIndex], reqItem);
            else
                self.models.push(reqItem);
        },
        updateModel: function (storeModel, action, storeState) {
            if (!action || storeModel?.model?.PageIsReloading || action?.messages?.some(m => m.State == -41)) return;

            const changedModelName = storeModel ? storeModel.model.modelName : action.model || action.modelName || "";

            const fieldsToUpdate = getAffectedFields(action, changedModelName);
            if (!fieldsToUpdate.length) return;

            const changedModel = findAFIllModel(changedModelName);

            self.trace("changed:", changedModelName, "| field:", (action.field || {}).field, "=", (action.field || {}).data, "-> recalc:", fieldsToUpdate.map(f => f.DependedFieldName).join(", "));

            sendBatchUpdate(changedModel, fieldsToUpdate, storeModel, action, storeState)
                .then(result => {
                    if (self.debug && result && result.data && !result.stale) {
                        const afnames = result.updatedFields.map(f => f.DependedFieldName).join(",");
                        const fvalues = result.data.UpdatedAutofillFields.map(f => f.DependedFieldName + "=" + f.Value).join(",\r\n");
                        console.log("-autofill updated:" + changedModelName + ", " + (action.field || {}).field + '>>>' + afnames, { action, result, fvalues });
                    }
                }).catch(error => {
                    console.log("-autofill error:" + changedModelName + ", " + (action.field || {}).field, { error, fieldsToUpdate, action });
                });
        }
    };

    function getAffectedFields(action, changedModelName) {
        const afield = action.field;
        const chFieldName = afield && afield.field ? afield.field.toLowerCase() : "";

        const changedModel = findAFIllModel(changedModelName);

        if (!changedModel) return [];
        const isDeleting = (action.type || "") == XPortal.Redusers.ACTIONS.DELETED_ENTITY;
        const directFields = isDeleting ? [] : getDirectModelFields(changedModel, chFieldName);
        const other_Fields = getOtherModelsFields((changedModel.alias || "").toLowerCase(), chFieldName, changedModelName);
        return [...directFields, ...other_Fields];
    };
    function getDirectModelFields(changedModel, chFieldName) {
        if (!changedModel.autofillFieldsSetup) changedModel.autofillFieldsSetup = [];
        const filteredSetups = !chFieldName ? changedModel.autofillFieldsSetup : changedModel.autofillFieldsSetup.filter(setup =>
            setup.AffectingFields.some(af =>
                af.toLowerCase() == chFieldName
            )
        );

        return enrichSetupFields(filteredSetups, changedModel);
    };
    function getOtherModelsFields(changedEntityAlias, changedFieldName, changedModelName) {
        const x = self.models.flatMap(m => {
            if (m.modelName == changedModelName) return [];
            const aliasFields = m.autofillFieldsSetup ? m.autofillFieldsSetup.filter(f => f.DependedEntity.toLowerCase() == changedEntityAlias) : [];
            const affcdFields = !changedFieldName ? aliasFields : aliasFields.filter(f => f.AffectingFields.some(fn => fn.toLowerCase() == changedFieldName));
            return enrichSetupFields(affcdFields, null, m.alias, m.nodeId);
        });

        return x;
    }

    function findAFIllModel(modelName) {
        return self.models.find(model => model.modelName == modelName);
    };

    function enrichSetupFields(setupFields, model, modelname, nodeId) {
        if (!setupFields) return [];
        return setupFields.map(autoFillFld => ({
            ...autoFillFld,
            uniqueId: model && model.uniqueId,
            alias: modelname || model.alias,
            nodeId: nodeId || model.nodeId
        }));
    };

    function sendBatchUpdate(model, updatedFields, storeModel, action, storeState) {
        return new Promise((resolve, reject) => {
            // pin to the record the edit was about: prefer action.entity so a chained recalc
            // stays on that record even if the grid has rebound to another row
            var entity = (action && action.entity) || (storeModel && storeModel.entity) || null;
            var entityUniqueId = afEntityId(entity, model);

            model.pendingFields = model.pendingFields || {};
            const pending = model.pendingFields[entityUniqueId] || (model.pendingFields[entityUniqueId] = []);
            updatedFields.forEach(function (uf) {
                if (!pending.some(function (p) { return p.DependedFieldKey === uf.DependedFieldKey && p.nodeId === uf.nodeId; }))
                    pending.push(uf);
            });

            clearTimeout(model.batchUpdateTimeouts[entityUniqueId] || -1);
            AutofillFieldLoader("Start", updatedFields);
            model.batchUpdateTimeouts[entityUniqueId] = setTimeout(function () {
                XPortal.Utils.waitFor(function () {
                    const pendingNow = model.pendingFields[entityUniqueId] || updatedFields;
                    const depEntAlias = pendingNow.map(x => x.DependedEntity).filter(x => x && x.trim());
                    const depActiveMs = self.models.filter(m => (m.requestingCount || 0) > 0 && depEntAlias.find(rma => rma == m.alias) != null);
                    if (depActiveMs && depActiveMs.length) return false;

                    const fieldsToSend = model.pendingFields[entityUniqueId] || updatedFields;
                    model.pendingFields[entityUniqueId] = [];

                    const requestData = getRequestModel(model, fieldsToSend, storeModel, action, storeState, entity);
                    if (!requestData.updatedFields || !requestData.updatedFields.length) {
                        resolve(null);
                        return true;
                    }

                    model.reqSeq = (model.reqSeq || 0) + 1;
                    model.latestRequestNo = model.latestRequestNo || {};
                    model.latestRequestNo[entityUniqueId] = model.reqSeq;

                    executeRequest(model, fieldsToSend, requestData, action, entityUniqueId, model.reqSeq, entity)
                        .then(o => resolve(o))
                        .catch(e => reject(e));
                    return true;
                }, XPortal.Utils.waitFor, 10, 10000);

            }, self.timeOut);
        });
    };

    // stable per-row identifier (cross-row autofill issue)
    function afEntityId(entity, model) {
        if (entity) {
            if (entity.uid) return entity.uid;
            if (entity.UniqueId) return entity.UniqueId;
        }
        return (model && model.entityUId) || "";
    }
    // ignore a response only if a NEWER request for the SAME entity was issued after it
    function isStaleAutofillResponse(model, entityUniqueId, seq) {
        const latest = (model.latestRequestNo || {})[entityUniqueId];
        if (latest != null && latest != seq) return true;
        return false;
    }
    function executeRequest(model, updatedFields, requestData, action, entityUniqueId, seq, entity) {
        const fnames = updatedFields.map(x => x.DependedFieldName + (model.nodeId != x.nodeId ? ":" + x.nodeId : "")).join(",");
        console.log("-autofill requesting: " + model.alias + ", " + (action.field || {}).field + '>>>' + fnames, { action, requestData });
        self.trace("-> REQUEST", model.alias, "seq#" + seq, "entity:", entityUniqueId, "| recalc:", fnames);
        return new Promise((resolve, reject) => {
            model.requestingCount = (model.requestingCount || 0) + 1;
            XPortal.Utils.APIPost("/umbraco/Surface/Autofill/Recalculate?pfs=" + model.nodeId + "_" + model.requestNumber + ":" + fnames + "/" + (model.alias || "").replaceAll(" ", "_"), requestData, { contentType: "application/json" })
                .then(function (data) {
                    model.requestingCount = Math.max(0, (model.requestingCount || 1) - 1);
                    self.trace("<- RESPONSE", model.alias, "seq#" + seq, "|", ((data && data.UpdatedAutofillFields) || []).map(f => f.DependedFieldName + "=" + f.Value).join(", ") || "(none)");
                    if (isStaleAutofillResponse(model, entityUniqueId, seq)) {
                        self.trace("DROP stale response", model.alias, "seq#" + seq, "(a newer request for the same entity superseded it)");
                        resolve({ data, updatedFields, stale: true });
                        setTimeout(() => { AutofillFieldLoader("Finish", updatedFields); }, 500);
                        return;
                    }
                    updateFields(data, action, model.modelName, entity);
                    resolve({ data, updatedFields });

                    setTimeout(() => {
                        AutofillFieldLoader("Finish", updatedFields);
                    }, 500);
                })
                .fail(function (xhr) {
                    model.requestingCount = Math.max(0, (model.requestingCount || 1) - 1);
                    console.error("Autofill server update error:", xhr.responseText);
                    reject(xhr);

                    setTimeout(() => {
                        AutofillFieldLoader("Finish", updatedFields);
                    }, 500);
                });
        });
    }
    function AutofillFieldLoader(status, updatedFields) {
        if (!Array.isArray(updatedFields) || updatedFields.length === 0) return;

        $(".default-autofill-hidden").each(function () {
            const hiddenField = $(this);
            const fieldName = hiddenField.data("metadata-fieldname");

            const matchingFieldContainer = $(".field-cntr.form-group").filter(function () {
                return $(this).find(`[data-metadata-fieldname="${fieldName}"]`).length > 0;
            });
            matchingFieldContainer.addClass("default-autofill");
        });

        updatedFields.forEach(field => {
            const fieldName = field.DependedFieldName;
            let defAutofillFields = $(".default-autofill");
            if (!defAutofillFields || defAutofillFields.length === 0) return;
            const matchingContainers = defAutofillFields.filter(function () {
                return $(this).find(`[data-metadata-fieldname="${fieldName}"]`).length > 0;
            });

            if (matchingContainers.length === 0) return;

            switch (status) {
                case "Start":
                    matchingContainers.addClass("loading");
                    break;
                case "Finish":
                    matchingContainers.removeClass("loading");
                    break;
                default:
                    console.warn("SetAutofillFieldStatus: Unknown status", status);
                    break;
            }
        });
    };
    // requestModelName/requestEntity: the exact record this response was computed for; its fields
    // are applied to that record even if the grid has since rebound to another row
    function updateFields(data, action, requestModelName, requestEntity) {
        const updFields = data.UpdatedAutofillFields;
        const isRemoveLine = action.type === "DELETED_ENTITY";

        if (!updFields) return;

        const modelsToSearch = isRemoveLine
            ? self.models.filter(m => m.modelName.includes("detail"))
            : self.models;

        updFields.forEach(p => {
            const model = modelsToSearch.find(m => {
                return m.autofillFieldsSetup && m.autofillFieldsSetup.some(x => x.DependedFieldKey === p.DependedFieldKey)
            });
            const storeModel = model ? XPortal.Store.GetModelByName(model.modelName) : null;
            if (!model || !storeModel) {
                self.trace("? no target model for", p.DependedFieldName, "(key " + p.DependedFieldKey + ") - value", p.Value, "not applied");
                return;
            }
            if (requestEntity && requestModelName && model.modelName === requestModelName) {
                self.trace("apply", model.modelName + "." + p.DependedFieldName, "=", p.Value, "(-> request record)");
                XPortal.Store.DispatchForOtherEntity(model.modelName, requestEntity, [{ name: p.DependedFieldName, value: p.Value }], true, null, true, true);
            } else {
                self.trace("apply", model.modelName + "." + p.DependedFieldName, "=", p.Value);
                XPortal.Store.DispatchByName(model.modelName, p.DependedFieldName, p.Value);
            }
        });
    };


    function getRequestModel(model, updatedFields, storeModel, action, storeState, entity) {
        entity = entity || (storeModel && storeModel.entity) || null;
        let modified = entity
            ? convertEditEntityToSave(entity, null, true)
            : { nodeId: model.nodeId };

        if (!modified.UniqueId) modified.UniqueId = model.entityUId || (entity ? entity.UniqueId : "") || "";
        if (!modified.EntityAlias) modified.EntityAlias = model.alias;
        if (!modified.NodeId) modified.NodeId = model.nodeId;
        if (!storeState) storeState = {};
        return Object.assign({}, modified, {
            updatedFields,
            requestNumber: model.requestNumber++,
            pageItems: getPageItems(storeModel, action, storeState),
            gridItems: getCurrentGridItems(model, storeModel, action, storeState),
            parentInfo: model.parentInfo
        });
    };


    function getCurrentGridItems(model, storeModel, action, storeState) {
        const cModel = XPortal.Store.GetModelByName(model.modelName, (storeState || {}).pageModels);
        if (!cModel || !cModel.GridModel) return null;

        return extractGridItems(cModel, storeState.pageModels);
    };

    function getPageItems(storeModel, action, storeState) {
        let pItems = [];
        const sModels = sortItems();
        sModels.forEach(({ modelName }) => {
            const cModel = XPortal.Store.GetModelByName(modelName, storeState.pageModels);
            if (cModel && cModel.entity && !cModel.GridModel) {
                pItems.push(extractDetailModels(cModel));
            }
            if (cModel && cModel.GridModel) {
                pItems.push(...extractGridItems(cModel, storeState.pageModels));
            }
        });
        return pItems;
    };

    function extractDetailModels(cModel) {
        return convertEditEntityToSave(cModel.entity, cModel.model.parentInfo, true);
    };

    function extractGridItems(cModel, pageModels) {
        const gridItems = getGridItems(cModel) || [];
        const prtModel = XPortal.Store.GetParentModel(cModel, pageModels);
        const prntInfo = cModel.GridModel.options.pageData.details.parentInfo;
        return gridItems.map(item => {
            const convertedItem = convertEditEntityToSave(item, prntInfo, true);
            if (!convertedItem.NodeId) convertedItem.NodeId = cModel.model.NodeId;
            return convertedItem;
        });
    };

    function convertEditEntityToSave(item, prntInfo, excludeEmptyFields) {
        var r = XPortal.Store.ConvertEditEntityToSave(item, prntInfo);
        if (excludeEmptyFields || !r || !r.Fields) {
            const rflds = [];
            _.each(r.Fields, (f) => {
                if (f.Data !== "") rflds.push(f);
            });
            r.Fields = rflds;
        }
        sendDateTimesAsUtc(r, item);
        return r;
    };
    function sendDateTimesAsUtc(r, item) {
        if (!r || !r.Fields || !item) return;
        r.Fields.forEach(function (f) {
            if (((f.Ftype || f.ftype || "") + "").toLowerCase() !== "datetime") return;
            if (f.Data == null || f.Data === "") return;
            var propName = XPortal.Template.GetObjPropName(item, f.Field || f.field);
            var display = propName ? item[propName] : null;
            if (display != null && display !== "") {
                var localStr = XPortal.Utils.FormatDateTimeNaive(display); // member-local time
                var d = new Date(localStr);
                if (!isNaN(d.getTime())) {
                    f.Data = moment(XPortal.Utils.AdjustDT(d, false)).toISOString(); // member-local -> UTC, Z-marked
                    return;
                }
            }
            if (XPortal.Utils.IsNaiveDateTimeValue(String(f.Data)))
                f.Data = String(f.Data).replace(" ", "T") + "Z";
        });
    };
    function getGridItems(cModel) {
        let items = cModel.GridModel.dataSource.view();
        return items;
    };



    function sortItems() {
        return self.models.sort((a, b) => {
            const aIsDetail = a.modelName.includes("detail");
            const bIsDetail = b.modelName.includes("detail");

            if (!aIsDetail && bIsDetail) return -1; // Grid first
            if (aIsDetail && !bIsDetail) return 1; // Detail later
            return 0;
        });
    };

    return self;
})();

